import { Button } from "@/components/ui/button";
import { LogOut, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Tela de "conta sem permissões" — mostrada quando um usuário autenticado tem
// `perms_matrix` vazia/ausente e portanto não pode ver nenhum item do sidebar.
// Existe pra evitar o loop de redirect (Dashboard nega → volta pra "/" → volta
// pro tenant → nega de novo) que fazia o sidebar piscar (bug fev/2026).
export default function NoAccessScreen() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-orange-50/40 flex items-center justify-center px-4" data-testid="no-access-screen">
      <div className="max-w-md w-full bg-white rounded-lg border border-orange-200 shadow-sm p-8 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-4">
          <ShieldAlert className="w-8 h-8 text-amber-600" />
        </div>
        <h1 className="text-xl font-bold text-slate-800 mb-2">Conta sem permissões</h1>
        <p className="text-sm text-slate-600 mb-1">
          Olá, <strong>{user?.nome || user?.email}</strong>. Sua conta ainda não tem nenhum
          acesso configurado.
        </p>
        <p className="text-sm text-slate-500 mb-6">
          Peça ao administrador da sua empresa para configurar suas permissões
          (Usuários → editar → Matriz de Permissões).
        </p>
        <Button onClick={logout} variant="outline" className="w-full" data-testid="no-access-logout">
          <LogOut className="w-4 h-4 mr-2" /> Sair
        </Button>
      </div>
    </div>
  );
}
